import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddbonustypepopupComponent } from '../../generalpopup/addbonustypepopup/addbonustypepopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import moment from 'moment';

@Component({
  selector: 'app-addbonus',
  templateUrl: './addbonus.component.html',
  styleUrls: ['./addbonus.component.css']
})
export class AddBonusComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "BONUS";

  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;

  isbonustypeaddmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;
  iscomments: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;

  ismanualclose: boolean;
  
  isemploading: boolean=false;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterbonustypeid: any = null;
  filterbonustypename: any = null;
  filterpaymentstatus: string = "ALL";
  //Edit Get Values
  bonusColl: any = [];
  bonusid: number = 0
  bonusBO: any = {}

  bonustypeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  

  checkfeildmsg: any = "";

  bonusform = new FormGroup({
    bonusid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    bonustypeid: new FormControl(null, Validators.required),
    amount: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    effectivedt: new FormControl('', Validators.required),
    inactive: new FormControl(false),
    isaffectpayroll: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService,public router: Router, private toastr: ToastrService, 
    private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.bonusid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.bonustypeid !== undefined) {
        this.filterbonustypeid = params.bonustypeid
      }
      if (params.bonustypename !== undefined) {
        this.filterbonustypename = params.bonustypename
      }
      if (params.paymentstatus !== undefined) {
        this.filterpaymentstatus = params.paymentstatus
      }
    })
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.bonusform.reset();
      this.fnInitializeFormGroup();

      if (this.bonusid > 0) {
        this.fngetBonus();
      }
      this.fngetBonusType();
      this.fngetEmployee();
     
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.bonusid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')


    this.isbonustypeaddmode = this.loginService.fnCheckUserRoleAction("BonusType", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.bonusform.setValue({
      bonusid: 0,
      empid: null,
      bonustypeid: null,
      amount: '',
      transdt: new Date(),
      descr: '',
      effectivedt: this.loginService.fnLastDate(new Date()),
      inactive: false,
      isaffectpayroll: false,
    })
  }
 
  fngetBonusType() {
    var data = {
      'bonustypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBonusType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.bonustypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    this.isemploading = true;

    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading=false
          if (res.json().status === 200) {
            this.empColl = res.json().result;

            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading=false
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetBonus() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'bonusid': this.bonusid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetBonus(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            console.log(res.json().result)
            this.bonusColl = res.json().result;
            var editdata = this.bonusColl[0];
            this.bonusBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }


  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.bonusform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }


  }

  fnResetValidation() {
    if (this.loginService.fnCheckFornControlNotfound(this.bonusform.get('effectivedt'))) {
      this.bonusform.controls['effectivedt'].setErrors(null);
    }

    if (this.loginService.fnCheckFornControlNotfound(this.bonusform.get('inactive'))) {
      this.bonusform.controls['inactive'].setErrors(null);
    }
  }

  fnSetValidation() {
    let _ischeck = false;
    if (this.loginService.fnCompareDateValidation(this.bonusform.get('effectivedt').value, this.bonusform.get('transdt').value)) {
      this.bonusform.controls['effectivedt'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    return _ischeck;
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate
      if (this.bonusform.valid) {

        if (this.fnSetValidation()) {
          return;
        }

        //Check
        var data = {
          'bonusid': this.bonusid,
          'transdt': this.fnFormatDatetime(this.bonusform.get('transdt').value),
          'empid': this.bonusform.get('empid').value,
          'bonustypeid': this.bonusform.get('bonustypeid').value,
          'amount': this.bonusform.get('amount').value,
          'descr': this.bonusform.get('descr').value,
          'effectivedt': this.fnFormatDatetime(this.bonusform.get('effectivedt').value),
          'inactive': this.bonusform.get('inactive').value,
          'isaffectpayroll': this.bonusform.get('isaffectpayroll').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckBonus(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresponce = res.json().result[0];

              var _checkresult = _checkresponce.checkfield;

              if (_checkresult === 'done') {
                if (this.bonusform.get('bonusid').value > 0) {
                  //Update 
                  this.fnSetBonus(data);
                }
                else {
                  //Insert 
                  this.fnInsertBonus(data);
                }
              }
              else {
                if (_checkresult === "COMMON") {

                  this.checkfeildmsg = _checkresponce.checkvaluemsg;

                  this.bonusform.controls['inactive'].setErrors({ 'notfound': true });
                }
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });



      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertBonus(data) {

    this.appService.fnInsertBonus(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The new bonus has been added successfully.");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));

            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].bonusid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetBonus(data) {

    this.appService.fnSetBonus(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag()
            this.toastr.success('', "The bonus has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.bonusid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.bonusid);

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }



  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }

  //AddBonusType
  private fnAddBonusType() {

    const modalRef = this.productFindService.open(AddbonustypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetBonusType();

      if (receivedEntry > 0) {
        this.bonusform.patchValue({ bonustypeid: receivedEntry })
      }
    });

  }

  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.bonusid;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.transdate = this.bonusBO.transdt;
    modalRef.componentInstance.transpaymodeid = this.bonusBO.transpaymodeid;
    modalRef.componentInstance.refno = this.bonusBO.payrefno;
    modalRef.componentInstance.paiddt = this.fnConvertDatetime(this.fnFormatDatetime(this.bonusBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.bonusBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetBonus();
      }

    });

  }
  public fnRemovePayment() {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to Remove Payment?')
        .then((confirmed) => {
          if (confirmed) {
           this.fnSetRemovePayment()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  private fnSetRemovePayment() {
    var data = {
      'trxid': this.bonusid,
      'formname': this.formname,
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.fnSetRemovePayment(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The Payment has been Removed successfully.");
            //this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetBonus();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnAddActivity(){

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.bonusid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      

     
    });

  } 

  fnEditFormEdit(id) {

    this.bonusid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'bonustypeid': this.filterbonustypeid,
      'bonustypename': this.filterbonustypename,
      'paymentstatus':this.filterpaymentstatus ,
    }



    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });
  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      } else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'bonustypeid': this.filterbonustypeid,
            'bonustypename': this.filterbonustypename,
            'paymentstatus':this.filterpaymentstatus ,
          }
        }

        this.router.navigate(['/Bonus'], navigationExtras);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));

    this.bonusform.setValue({
      bonusid: deptBO.bonusid,
      empid: deptBO.empid,
      bonustypeid: deptBO.bonustypeid,
      amount: deptBO.amount,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      effectivedt: deptBO.effectivedt,
      inactive: deptBO.inactive,
      isaffectpayroll: deptBO.isaffectpayroll

    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount()
  }
  //Comment
  fnCommentsBtnClick() {

    this.iscomments = true;
  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetBonus();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.bonusBO.approvedstatus !== '') {
      if (this.bonusBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.bonusBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }


  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.bonusid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();


    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetBonus();
      }
      this.fnGetAttachmentCount()
    });

  }


  fnAttachmentSave(tid) {



  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.bonusid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetBonus();
      }


    });
  }




  //Attachment
  fnGetAttachmentCount() {
    if (this.bonusid > 0) {
      var data = {
        'trxid': this.bonusid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }


  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}